import React from 'react';

const BlogArticle = ({ title, date, commentsCount, description }) => (
    <div className="col-md-6 col-lg-4">
        <a className="single-blog-article border rounded bg-white d-block p-4 mt-4" href="#">
            <div className="article-heading">
                <h3 className="h5 mb-0">{title}</h3>
                <span>On {date}</span>
            </div>
            <span className="border-shape my-3"></span>
            <p>{description}</p>
            <div className="article-footer d-flex align-items-center justify-content-between">
                <div className="article-comments">
                    <span><i className="fas fa-comment mr-1"></i> {commentsCount} Comments</span>
                </div>
                <div className="article-user">
                    <span className="fas fa-user"></span>
                </div>
            </div>
        </a>
    </div>
);

const OurBlogSection = () => {
    return (
        <section className="our-blog-section ptb-100 gray-light-bg">
            <div className="container">
                {/* Section Heading */}
                <div className="row justify-content-center">
                    <div className="col-md-9 col-lg-6">
                        <div className="section-heading text-center">
                            <h2>Recent News and Events</h2>
                            <p>
                                Efficiently matrix robust total linkage after market positioning bandwidth materials rather
                                than brand flexible paradigms vis-a-vis mission-critical e-commerce.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Blog Articles */}
                <div className="row justify-content-center">
                    <BlogArticle
                        title="Professionally cultivate testing"
                        date="20 Mar, 2020"
                        commentsCount={34}
                        description="Enthusiastically pursue tactical architectures vis-a-vis goal-oriented resources."
                    />
                    <BlogArticle
                        title="Monotonectally promote market"
                        date="20 May, 2020"
                        commentsCount={24}
                        description="Enthusiastically pursue tactical architectures vis-a-vis goal-oriented resources."
                    />
                    <BlogArticle
                        title="Seamlessly evolve interactive"
                        date="10 Mar, 2020"
                        commentsCount={20}
                        description="Enthusiastically pursue tactical architectures vis-a-vis goal-oriented resources."
                    />
                </div>
            </div>
        </section>
    );
};

export default OurBlogSection;
